function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import 'scss/cndc_prices.scss';
import { initializePlot } from './helpers';
import { PlotContainer } from './style';

var StackedBarPlot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StackedBarPlot, _React$Component);

  function StackedBarPlot() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StackedBarPlot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StackedBarPlot)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.shouldComponentUpdate = function (nextProps) {
      if (_this.props.windowWidth != nextProps.windowWidth) return true;
      if (_this.props.plotID != nextProps.plotID) return true;
      if (_this.props.data != nextProps.data) return true;
      return false;
    };

    _this.render = function () {
      initializePlot(_this.props);
      return React.createElement("div", {
        className: "col-sm-12 col-md-12"
      }, React.createElement(PlotContainer, {
        id: "".concat(_this.props.plotID, "_graph"),
        className: "data-page__section__graph data-page__section__graph--barplot ".concat(_this.props.plotID, "-graph")
      }), React.createElement("div", null));
    };

    return _this;
  }

  _createClass(StackedBarPlot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      initializePlot(this.props);
    }
  }]);

  return StackedBarPlot;
}(React.Component);

export { StackedBarPlot as default };
StackedBarPlot.propTypes = {
  plotID: PropTypes.string,
  plot: PropTypes.object,
  loading: PropTypes.bool,
  countryID: PropTypes.string,
  actions: PropTypes.object,
  windowWidth: PropTypes.number,
  checkboxState: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};